import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './dynamicCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import FiltersModule from '../../filters/filters';

export class DynamicCreativesFormController {
  /* @ngInject */
  constructor($scope, currentGame, GamesResource, $stateParams, $filter, Upload, setProgressBar, notify) {
    this.$scope = $scope;
    this.currentGame = currentGame;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.Upload = Upload;
    this.setProgressBar = setProgressBar;
    this.notify = notify;
    this.statusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.validFileTypes = [ 'image/png',
      'image/jpeg',
      'image/pjpeg',
      'image/gif'
    ];

    if(!this.creative.id) {
      this.creative.active = true;
    }
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;
      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }
}

let DynamicCreativesFormComponent = {
  template: () => { return template },
  controller: DynamicCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.dynamicCreativesForm', [
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name,
  FiltersModule.name
])
  .component('dynamicCreativesForm', DynamicCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/dynamicCreativesForm.js
 **/